import React from 'react';
import MentalsIndex from './MentalsIndex';
import api from '../../lib/MentalApi';

const MentalsIndexPage = () => {
    const mentals = api.getMentalsIndex();
    const favoritesItem = api.getFavoritesItem();

    return (
        <MentalsIndex
            favoritesItem={favoritesItem}
            mentals={mentals}
        />
    );
};

export default MentalsIndexPage;
